import { useState } from 'react';

const ActionTracker = ({ actions_count, cKey, handleCheck, nested=false, actionIndex=undefined}) => {
    const [hoverIndex, setHoverIndex] = useState(null);

    const filledCircles = actions_count % 10;
    const totalCircles = Math.floor(actions_count / 10);
    let isHoveringFilled = filledCircles > hoverIndex

    const handleMouseEnter = (index) => {
        setHoverIndex(index);
    };

    const handleMouseLeave = () => {
        setHoverIndex(null);
    };

    const handleClick = (e, index) => {
        if(hoverIndex === index) {
            setHoverIndex(prev => isHoveringFilled ? prev-100 : prev+100)
        }
        // This detemines adding or subtracting from rechargeCount
        let addCheck = index >= filledCircles
        let newFilled = addCheck ? actions_count + 1 : actions_count - 1

        // add or minus counts as newValue
        let action = addCheck ? "addRecharge" : "minusRecharge"

        handleCheck(newFilled, action, cKey);
        // handleCheck(addCheck, cKey, nested, actionIndex);
        e.stopPropagation();
    };

    const getClass = (index) => {
        //if im hovering
        if(hoverIndex != null) {
            //over a filled box
            if(isHoveringFilled) {
                // and this index is right most
                if(index === filledCircles-1) {
                    return 'filled hover'
                }
    
            //over a unfilled box and this index is first unfilled
            } else if(index === filledCircles) {
                return 'unfilled hover'
            }
        }

        return index < filledCircles ? 'filled' : 'unfilled'
    }

    return (
        <>
            {Array.from({ length: totalCircles }).map((_, index) => (
                <div
                    key={index}
                    className={`actionToken ${getClass(index)}`}
                    onClick={(e) => handleClick(e, index)}
                    onMouseEnter={() => handleMouseEnter(index)} // Track hover
                    onMouseLeave={handleMouseLeave} // Reset hover when mouse leaves the container
                />
            ))}
        </>
    );
};

export default ActionTracker;